<template>
  <MainPage>
    <div class='page-login-form'>
      <div class='logo-arvalis'/>
      <div class='wrap'>
        {{ messageValidate }}
      </div>
      <input type='button' class="primary-action" @click='retour' value="Retour" />
    </div>
  </MainPage>
</template>

<script>
import MainPage from './MainPage'
import { execValidate } from '@/api/client-api'

export default {
  name: 'validate',

  components: {
    MainPage
  },

  data () {
    return {
      messageValidate: ''
    }
  },
  props: {
    token: {
      type: String,
      require: true
    }
  },
  mounted: function () {
    this.doValidate()
  },
  methods: {
    doValidate () {
      execValidate(this.token)
        .then((r) => {
          this.messageValidate = r
        })
        .catch((err) => {
          alert(err)
        })
    },
    retour () {
      this.$router.push({ name: 'login' })
    }
  }
}
</script>
